import { useMemo } from "react";
import type { ICartDishItem } from "@/types";
import { useCartMenuStorage } from "@/components/cart/hooks/useCartMenuStorage";

export const useCartItems = (menuId: number | null): ICartDishItem[] => {
  const storage = useCartMenuStorage(menuId);

  return useMemo(() => {
    return Object.values(storage.itemsByDishId ?? {});
  }, [storage.itemsByDishId]);
};
